export const cmsMenuLayerProps = () => ({
  category: {
    type: Object,
    required: true
  }
})

export const useCmsMenuLayer = () => {
  const currentChild = ref(null);
  const showChild = (child) => {
    currentChild.value = child;
  };
  const hideChild = () => {
    currentChild.value = null;
  }

  return {
    currentChild,
    showChild,
    hideChild
  }
}